import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiOpenmindService } from '../apiopenmind.service';
import { SharedDataService } from "../shared-data.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})


export class HomeComponent {

  user = {
    email: '',
    password: '',
    errorMessage:''
  }
  objUser = {};

  constructor(private router: Router, private apiopenmindservice: ApiOpenmindService, private sharedData: SharedDataService) { }

  loginUser() {
    this.apiopenmindservice.LoginUser(this.user).subscribe(event => {
      this.objUser = event, this.validateUser()
    }, error => { this.user.errorMessage = 'Verifica los datos ingresados '; });
  }


  validateUser() {
    this.sharedData.userLoggedSession(this.objUser);
    sessionStorage.setItem("loginData", JSON.stringify(this.objUser));
    this.router.navigate(['/program-list']);
  }

}
